"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const icon_1 = __importDefault(require("../icon"));
const { ArrowDown, ArrowRight } = icon_1.default;
const StyledDropdownWrapper = styled_components_1.default.div `
  position: relative;
  width: fit-content;
`;
const StyledDropdownHeader = styled_components_1.default.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: solid 1px ${({ theme }) => theme.neutral.main};
  border-radius: 4px;
  background-color: ${({ opensToRight, isOpen, theme }) => opensToRight && isOpen ? theme.neutral.lighter : theme.white};
  padding: 7px 12px;
  cursor: pointer;
  width: fit-content;
  min-width: 142px;
`;
const StyledHeaderLabel = styled_components_1.default.div `
  font-size: 14px;
  color: ${({ theme }) => theme.neutral.dark};
  margin-right: 10px;
`;
const StyledDot = styled_components_1.default.div `
  width: 6px;
  height: 6px;
  border-radius: 20px;
  margin: 0 12px 0 auto;
  background-color: ${({ theme }) => theme.primary.main};
  opacity: ${({ isVisible }) => (isVisible ? 1 : 0)};
`;
const StyledDropdownBody = styled_components_1.default.div `
  position: absolute;
  top: ${({ headerHeigh, opensToRight }) => opensToRight ? "0px" : `${headerHeigh + 4}px`};
  left: ${({ headerWidth, opensToRight }) => opensToRight ? `${headerWidth + 4}px` : "0"};
  width: fit-content;
  z-index: 10;
  box-shadow: 0px 25px 50px 0 #0002;
  border-radius: 4px;
  width: max-content;
`;
const StyledArrowDown = (0, styled_components_1.default)(ArrowDown) `
  transform: ${({ isOpen }) => (isOpen ? "rotate(180deg)" : "rotate(0deg)")};
  transition: all 0.2s linear;
`;
const RotaDropdownHeader = (_a) => {
    var _b, _c;
    var { isOpen, setIsOpen, labelText, children, shouldShowDot, opensToRight = false, onClose } = _a, props = __rest(_a, ["isOpen", "setIsOpen", "labelText", "children", "shouldShowDot", "opensToRight", "onClose"]);
    const theme = (0, styled_components_1.useTheme)();
    const headerRef = (0, react_1.useRef)(null);
    const wrapperRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        if (isOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        }
        else {
            document.removeEventListener("mousedown", handleClickOutside);
            onClose === null || onClose === void 0 ? void 0 : onClose();
        }
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [isOpen]);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleClickOutside = (e) => {
        var _a;
        const isClickInside = (_a = wrapperRef === null || wrapperRef === void 0 ? void 0 : wrapperRef.current) === null || _a === void 0 ? void 0 : _a.contains(e.target);
        !isClickInside && setIsOpen(false);
    };
    return (react_1.default.createElement(StyledDropdownWrapper, Object.assign({ ref: wrapperRef }, props),
        react_1.default.createElement(StyledDropdownHeader, { ref: headerRef, onClick: () => setIsOpen(!isOpen), opensToRight: opensToRight, isOpen: isOpen },
            react_1.default.createElement(StyledHeaderLabel, null, labelText),
            react_1.default.createElement(StyledDot, { isVisible: shouldShowDot }),
            opensToRight ? (react_1.default.createElement(ArrowRight, { color: theme.neutral.dark })) : (react_1.default.createElement(StyledArrowDown, { isOpen: isOpen, color: theme.neutral.dark }))),
        isOpen && (react_1.default.createElement(StyledDropdownBody, { opensToRight: opensToRight, headerHeigh: ((_b = headerRef === null || headerRef === void 0 ? void 0 : headerRef.current) === null || _b === void 0 ? void 0 : _b.offsetHeight) || 0, headerWidth: ((_c = headerRef === null || headerRef === void 0 ? void 0 : headerRef.current) === null || _c === void 0 ? void 0 : _c.offsetWidth) || 0 }, children))));
};
exports.default = RotaDropdownHeader;
